import React, { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import useProductNewArrival from '../../hooks/useProductNewArrival';
import { useAppConfig } from '../../context/AppConfigContext';
import { formatCurrency, DEFAULT_COUNTRY_CODE } from '../../constants';
import Flag from 'react-world-flags';

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const ProductListNewArrival = () => {
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const { fetchProductNewArrival, data, status, error, resetStatus } = useProductNewArrival();
    const [dataProduct, setDataProduct] = React.useState([]);

    // const { currency } = useAppConfig();

    const formatPercentageDiscount = (discount, price) => {
        const percentage = ((price - discount) / price) * 100;
        return percentage.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    useEffect(() => {
        if (status === 'idle') {
            fetchProductNewArrival();
        }

        if (status === 'done') {
            setDataProduct(data);
        }
        // console.log(data);
        // console.log(status);
    }, [status]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: false,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    };
    return (
        <div className="newarrivalproducts-slider arrow-style-two">
            {dataProduct.length > 0 && (
                <Slider {...settings}>
                    {dataProduct.map((item, index) => (
                        <div key={index} className="pb-1" style={{ minHeight: '100%', padding: '0 8px' }}>
                            <div
                                className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2"
                                style={{ width: 'calc(100% - 8px)', maxWidth: 'calc(100% - 8px)', margin: '0 auto' }}
                            >
                                <div className="w-100">
                                    {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                        <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                                            Sale {Number(item?.discount)?.toFixed(0)?.toLocaleString('en-US')}%
                                        </span>
                                    )}
                                    <Link
                                        to={`/product-details/${encodeURIComponent(item?.slug)}`}
                                        className="product-card__thumb flex-center"
                                    >
                                        <img
                                            // src={
                                            //     item.photoData && item.photoData.length > 0
                                            //         ? item.photoData[0].url
                                            //         : "/assets/images/no-image.png"
                                            // }
                                            src={item.photoData?.[0]?.url + '?width=235' || '/assets/images/no-image.png'}
                                            alt=""
                                            // className="w-auto max-w-unset"
                                        />
                                    </Link>
                                </div>

                                <div className="product-card__content p-sm-2" style={{ minWidth: '100%' }}>
                                    {/* <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-600">4.8</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-600">(17k)</span>
                                            </div>  */}

                                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                        <Link to={`/product-details/${encodeURIComponent(item?.slug)}`} className="link text-line-2">
                                            {item.name}
                                        </Link>
                                    </h6>
                                    <Link to={`/seller-store?storeid=${item.companyId}`}>
                                        <div className="flex-align gap-4">
                                            <span
                                                className="text-main-600 text-main-one-600 text-md d-flex"
                                                style={{ border: '1px solid #eeeeee', minWidth: '24px' }}
                                            >
                                                {/* <i className="ph-fill ph-storefront" /> */}
                                                <Flag code={item?.flag || DEFAULT_COUNTRY_CODE} width={'24'} />
                                            </span>
                                            <span
                                                className="text-gray-500 text-xs"
                                                style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                                            >
                                                <span>{item.businessName}</span>
                                                <img src="assets/images/icon/verified.png" width={14} height={14} />
                                            </span>
                                        </div>
                                    </Link>

                                    <div className="product-card__content mt-12 d-flex justify-content-between align-items-center">
                                        <div className="product-card__price mb-8 d-block">
                                            {
                                                //(item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "") &&
                                                Number(item.discountPrice) > 0 && (
                                                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                        {/* {currency}{" "} */}
                                                        {/* {
                                                                    //item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                                                                    Number(item.discountPrice) > 0 ? (
                                                                        item.price
                                                                    ) : (
                                                                        item.discountPrice
                                                                    )
                                                                } */}
                                                        {formatCurrency(item.discountPrice > 0 ? item.price : item.discountPrice)}
                                                    </span>
                                                )
                                            }
                                            <span className="text-heading text-md fw-semibold  d-block">
                                                {/* {currency}{" "} */}
                                                {/* {
                                                            //item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                                                            Number(item.discountPrice) > 0 ? (
                                                                item.discountPrice
                                                            ) : (
                                                                item.price
                                                            )
                                                        } */}
                                                {formatCurrency(item.discountPrice > 0 ? item.discountPrice : item.price)}{' '}
                                                <span className="text-gray-500 fw-normal">/Qty</span>{' '}
                                            </span>
                                        </div>

                                        <Link
                                            //to="/cart"
                                            to={`/product-details/${encodeURIComponent(item?.slug)}`}
                                            className="product-card__cart btn  rounded-pill flex-align gap-8  justify-content-center"
                                        >
                                            <span>Visit Now </span>
                                            {/* <i className="ph ph-shopping-cart" /> */}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            )}
        </div>
    );
};

export default ProductListNewArrival;
